import React, { useEffect, useState } from "react";
import { Button, Card } from "@material-ui/core";
import TableContainer from "@material-ui/core/TableContainer";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import { PATH } from "../../constants/appConstants";
import Divider from "@material-ui/core/Divider";
import { TextField, IconButton } from "@material-ui/core";
import { SearchOutlined, HowToReg, Delete } from "@material-ui/icons";
import { Dialog, DialogActions, DialogTitle, Tooltip } from "@mui/material";
import "./reservedCodes.scss";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useDispatch } from "react-redux";
import MTextField from "../../components/MTextField";
import { isFieldEmpty } from "../../helpers/appFieldValidation";
import { errorSnackbar, successSnackbar } from "../../actions/snackbarActions";
import AjaxHelper from "../../apis/apiRequest";
import { Endpoint, Status } from "../../apis/apiConstants";
import { startLoading, stopLoading } from "../../actions/loadingAction";
import { useNavigate } from "react-router";

export default function ReservedCodes(props) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const dispatch = useDispatch();
  const [open, setOpen] = React.useState(false);
  const [openAssign, setOpenAssign] = React.useState(false);
  const [reservedCode, setReservedCode] = React.useState("");
  const [selectedReservedCode, setSelectedReservedCode] = React.useState("");
  const [reservedCodes, setReservedCodes] = React.useState([]);
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    getReservedCodes();
  }, []);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setReservedCode("");
    setOpenAssign(false);
    setOpen(false);
  };

  const getReservedCodes = () => {
    dispatch(startLoading);
    AjaxHelper.getApi(navigate, Endpoint.GET_ALL_RESERVED_CODES)
      .then((response) => {
        dispatch(stopLoading);
        if (response.data.status === Status.API_SUCCESS) {
          setReservedCodes(response.data.data);
        } else {
          dispatch(errorSnackbar("Error fetching reserved codes."));
        }
      })
      .catch((error) => {
        dispatch(stopLoading);
        dispatch(errorSnackbar("Error fetching reserved codes."));
      });
  };

  const addReservedCode = () => {
    const msg = getValidation();
    if (msg && msg.length > 0) {
      dispatch(errorSnackbar(errorMessage));
    } else {
      handleClose();
      dispatch(startLoading);
      AjaxHelper.postApi(navigate, Endpoint.ADD_RESERVED_CODE, {
        userCode: reservedCode,
      })
        .then((response) => {
          dispatch(stopLoading);
          if (
            response.data.status === Status.API_CREATED ||
            response.data.status === Status.API_SUCCESS
          ) {
            dispatch(successSnackbar("Code reserved for future usage."));
            getReservedCodes();
          } else {
            dispatch(errorSnackbar("Error while adding reserved code."));
          }
        })
        .catch((err) => {
          dispatch(stopLoading);
          dispatch(errorSnackbar("Error while adding reserved code."));
        });
    }
  };

  const deleteReservedCode = (code) => {
    if (isFieldEmpty(code)) {
      dispatch(errorSnackbar("Please select valid reserved code."));
    } else {
      dispatch(startLoading);
      AjaxHelper.postApi(navigate, Endpoint.DELETE_RESERVED_CODE, {
        reservedCode: code,
      })
        .then((response) => {
          dispatch(stopLoading);
          if (response.data.status === Status.API_SUCCESS) {
            dispatch(successSnackbar("Code removed."));
            getReservedCodes();
          } else {
            dispatch(errorSnackbar("Error while removing reserved code."));
          }
        })
        .catch((err) => {
          dispatch(stopLoading);
          dispatch(errorSnackbar("Error while removing reserved code."));
        });
    }
  };

  const assignReservedCode = () => {
    if (isFieldEmpty(reservedCode)) {
      dispatch(errorSnackbar("Please enter reserved code."));
    } else {
      handleClose();
      dispatch(startLoading);
      AjaxHelper.postApi(navigate, Endpoint.ASSIGN_RESERVED_CODE, {
        oldUserCode: reservedCode,
        newUserCode: selectedReservedCode,
      })
        .then((response) => {
          dispatch(stopLoading);
          if (
            response.data.status === Status.API_CREATED ||
            response.data.status === Status.API_SUCCESS
          ) {
            dispatch(successSnackbar("Code reserved for future usage."));
            getReservedCodes();
          } else {
            dispatch(errorSnackbar("Error while adding reserved code."));
          }
        })
        .catch((err) => {
          dispatch(stopLoading);
          dispatch(errorSnackbar("Error while adding reserved code."));
        });
    }
  };

  const getReservedCodesView = () => {
    return reservedCodes.map((code) => (
      <TableRow>
        <TableCell>{code.userCode}</TableCell>
        <TableCell align="center">
          <Tooltip title={"Assign"}>
            <IconButton
              onClick={() => {
                setSelectedReservedCode(code.userCode);
                setOpenAssign(true);
              }}
            >
              <HowToReg color={"primary"} />
            </IconButton>
          </Tooltip>
          <Tooltip title={"Delete"} className={"reject-icon"}>
            <IconButton onClick={() => deleteReservedCode(code.userCode)}>
              <Delete />
            </IconButton>
          </Tooltip>
        </TableCell>
      </TableRow>
    ));
  };

  //validation

  const getValidation = () => {
    if (
      (reservedCode && reservedCode.length === 8) ||
      (reservedCode && reservedCode.length === 12)
    ) {
      setErrorMessage("");
      return "";
    } else {
      setErrorMessage("Reserved code can only be 8 or 12 digits.");
      return "Reserved code can only be 8 or 12 digits.";
    }
  };

  return (
    <div className={"reserved-code-component d-flex flex-column p-md-3"}>
      <div className="d-flex flex-row align-items-center justify-content-between">
        <div className="">
          <TextField
            fullWidth
            placeholder="Search"
            InputProps={{
              endAdornment: (
                <IconButton>
                  <SearchOutlined />
                </IconButton>
              ),
            }}
          />
        </div>
        <Button
          variant="contained"
          className="mb-3 button"
          Style="margin-top: 25px;"
          color="primary"
          onClick={() => handleClickOpen()}
        >
          Add
        </Button>
      </div>
      <Card className="innerCard mt-3 " variant="outlined">
        <TableContainer component={Paper}>
          <Table aria-label="simple table">
            <TableHead>
              <TableRow className={"background-color-head"}>
                <TableCell>
                  <span className={"font-bold font-18"}>Code</span>
                </TableCell>

                <TableCell align="center">
                  <span className={"font-bold font-18"}>Actions</span>
                </TableCell>
              </TableRow>
            </TableHead>
            {getReservedCodesView()}
          </Table>
        </TableContainer>

        <Dialog
          fullScreen={fullScreen}
          open={open || openAssign}
          onClose={handleClose}
        >
          <DialogTitle className={"background-color-head"}>
            <span className={"font-bold font-18"}>
              {open
                ? "Add code to reserve"
                : `Assign ${selectedReservedCode} to`}
            </span>
          </DialogTitle>
          <Divider />

          <div className={"jamaat-form"}>
            <MTextField
              id={"code"}
              name={"reservedCode"}
              className="col-12"
              type={"number"}
              required={true}
              label={"Code"}
              value={reservedCode}
              onChange={(event) => setReservedCode(event.target.value)}
              maxLength={12}
              placeholder={"Code 8-12 digits"}
              error={errorMessage.length > 0}
              helperText={errorMessage}
            />
          </div>
          <DialogActions>
            <Button onClick={handleClose}>Cancel</Button>
            <Button
              onClick={() => (open ? addReservedCode() : assignReservedCode())}
            >
              Add
            </Button>
          </DialogActions>
        </Dialog>
      </Card>
    </div>
  );
}
